import { Routes, UrlSegment } from '@angular/router';
import { HomePage } from './feature/home/home';
import { RouteGuard } from './core/guards/route.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';
import { PartyManagementComponent } from 'app/feature/management-parties/pages/party-management/party-management.component';
import { ClaimsManagementComponent } from 'app/feature/management-claim/pages/list-claims/claims-management.component';
import { AddVehicleComponent } from './feature/management-vehicle/pages/add-vehicle/add-vehicle.component';
import { BrandManagementComponent } from './feature/management/brand-and-model/pages/brand-management/brand-management.component';
import { ModelDetailComponent } from './feature/management/brand-and-model/pages/model-detail/model-detail.component';
import { UsersManagementComponent } from './feature/management/users-management/pages/users-management/users-management.component';
import { RolesManagementComponent } from './feature/management/roles-management/pages/roles-management/roles-management.component';
import { EntityManagementComponent } from './feature/management/entity-management/pages/entity-management/entity-management.component';
import { MenusManagementComponent } from './feature/management/menus-management/pages/menus-management/menus-management.component';
import { ProcessDocumentManagementComponent } from './feature/management/process-document-management/pages/process-document-management/process-document-management.component';
import { ProcessDocumentDetailComponent } from './feature/management/process-document-management/pages/process-document-detail/process-document-detail.component';
import { DocRequirementAuditHistoryComponent } from './feature/management/process-document-management/pages/doc-requirement-audit-history/doc-requirement-audit-history.component';
import { RuleManagementComponent } from './feature/management/rule-management/pages/rule-management/rule-management.component';
import { StatusFlowListComponent } from './feature/management/status-flow-management/pages/status-flow-list/status-flow-list.component';
import { StatusFlowManagementComponent } from './feature/management/status-flow-management/pages/status-flow-management/status-flow-management.component';
import { FlowAuditHistoryComponent } from './feature/management/status-flow-management/pages/flow-audit-history/flow-audit-history.component';
import { StatusManagementComponent } from './feature/management/status-management/pages/status-management/status-management.component';
import { DocumentTypeManagementComponent } from './feature/management/document-type-management/pages/document-type-management/document-type-management.component';
import { ProcessManagementComponent } from './feature/management/process-management/pages/process-management/process-management.component';
import { ProcessCategoryManagementComponent } from './feature/management/process-category-management/pages/process-category-management/process-category-management.component';
import { RequestsComponent } from './feature/management-request/pages/requests/requests.component';
import { BillingManagementComponent } from './feature/management/billing-management/pages/billing-management/billing-management.component';
import { PeriodManagementComponent } from './feature/management/period-management/pages/period-management/period-management.component';
import { PaymentManagementComponent } from './feature/management/payment-management/pages/payment-management/payment-management.component';
import { ReimbursementManagementComponent } from './feature/management/reimbursement-management/pages/reimbursement-management/reimbursement-management.component';
import { ConfirmRequestComponent } from './feature/management-request/pages/confirm-request/confirm-request.component';
import { RequestHistoryComponent } from './feature/management-request/pages/request-history/request-history.component';
import { SessionPageComponent } from './feature/management-request/pages/session/session-page.component';
import { HelpManagementComponent } from './feature/management/help-management/pages/help-management/help-management.component';
import { MailManagementComponent } from './feature/management/mail-management/pages/mail-management/mail-management.component';

function prefixMatcher(...prefix: string[]) {
    return (segments: UrlSegment[]) => {
        if (prefix.length > segments.length) return null;
        if (!prefix.every((p, i) => segments[i]?.path === p)) return null;
        return { consumed: segments };
    };
}

export const routes: Routes = [
    { path: '', component: HomePage, data: { title: 'Home' } },
    { path: 'confirm-request', component: ConfirmRequestComponent, data: { title: 'Confirmación de Solicitud' } },
    {
        matcher: prefixMatcher('seguridad', 'usuarios'),
        component: UsersManagementComponent,
        data: { title: 'Gestión de Usuarios' },
        canActivate: [RouteGuard]
    },
    {
        matcher: prefixMatcher('seguridad', 'roles'),
        component: RolesManagementComponent,
        data: { title: 'Gestión de Roles' },
        canActivate: [RouteGuard]
    },
    { path: 'seguridad/entidades', component: EntityManagementComponent, data: { title: 'Gestión de Entidades' }, canActivate: [RouteGuard] },
    { path: 'seguridad/menus', component: MenusManagementComponent, data: { title: 'Gestión de Menús' }, canActivate: [RouteGuard] },
    {
        matcher: prefixMatcher('socios'),
        component: PartyManagementComponent,
        canActivate: [RouteGuard],
        data: { title: 'Home' }
    },
    { path: 'vehicle/add/:partyId', component: AddVehicleComponent, data: { title: 'Agregar Vehículo' }, canActivate: [RouteGuard] },
    {
        matcher: prefixMatcher('siniestros'),
        component: ClaimsManagementComponent,
        data: { title: 'Home' },
        canActivate: [RouteGuard]
    },
    {
        path: 'configuracion/importacion-masiva',
        loadComponent: () =>
            import('./feature/management/bulk-import/pages/bulk-import/bulk-import.component').then(
                (m) => m.BulkImportComponent
            ),
        data: { title: 'Importación masiva' },
        canActivate: [RouteGuard]
    },
    {
        path: 'configuracion/mantenedor-partes',
        loadComponent: () => import('./feature/management-vehicle/pages/vehicle-parts-manager/vehicle-parts-manager.component').then(m => m.VehiclePartsManagerComponent),
        data: { title: 'Mantenedor de Partes de Vehículo' },
        canActivate: [RouteGuard]
    },
    {
        path: 'configuracion/vehiculos/:brandCode/modelo/:modelCode',
        component: ModelDetailComponent,
        data: { title: 'Detalle de Modelo' },
        canActivate: [RouteGuard]
    },
    {
        matcher: prefixMatcher('configuracion', 'vehiculos'),
        component: BrandManagementComponent,
        data: { title: 'Home' },
        canActivate: [RouteGuard]
    },
    { path: 'configuracion/procesos', component: ProcessManagementComponent, data: { title: 'Gestión de Procesos' }, canActivate: [RouteGuard] },
    { path: 'configuracion/categorias-proceso', component: ProcessCategoryManagementComponent, data: { title: 'Categorías de Proceso' }, canActivate: [RouteGuard] },
    { path: 'configuracion/ayuda', component: HelpManagementComponent, data: { title: 'Documentación de ayuda' }, canActivate: [RouteGuard] },
    { path: 'configuracion/correos', component: MailManagementComponent, data: { title: 'Historial de Correos' }, canActivate: [RouteGuard] },
    {
        path: 'configuracion/documentos/historial',
        component: DocRequirementAuditHistoryComponent,
        data: { title: 'Historial de documentos' },
        canActivate: [RouteGuard]
    },
    {
        path: 'configuracion/tipos-documento',
        component: DocumentTypeManagementComponent,
        data: { title: 'Tipos de documento' },
        canActivate: [RouteGuard]
    },
    {
        path: 'configuracion/documentos/:processSlug/gestionar',
        loadComponent: () =>
            import('./feature/management/process-document-management/pages/manage-process-requirements/manage-process-requirements.component')
                .then((m) => m.ManageProcessRequirementsComponent),
        data: { title: 'Gestionar Requisitos de Documentos' },
        canActivate: [RouteGuard]
    },
    {
        path: 'configuracion/documentos',
        pathMatch: 'full',
        component: ProcessDocumentManagementComponent,
        data: { title: 'Gestión de Documentos de Proceso' },
        canActivate: [RouteGuard]
    },
    {
        path: 'configuracion/documentos/:processSlug',
        component: ProcessDocumentDetailComponent,
        data: { title: 'Requisitos de documentos' },
        canActivate: [RouteGuard]
    },
    { path: 'configuracion/flujos/historial', component: FlowAuditHistoryComponent, data: { title: 'Historial de flujos' }, canActivate: [RouteGuard] },
    { path: 'configuracion/flujos/editar/:processSlug', component: StatusFlowManagementComponent, data: { title: 'Editar flujo BPM' }, canActivate: [RouteGuard], canDeactivate: [unsavedChangesGuard] },
    { path: 'configuracion/flujos', pathMatch: 'full', component: StatusFlowListComponent, data: { title: 'Gestión de Flujos BPM' }, canActivate: [RouteGuard] },
    { path: 'configuracion/estados', component: StatusManagementComponent, data: { title: 'Gestión de Estados' }, canActivate: [RouteGuard] },
    { path: 'configuracion/reglas', component: RuleManagementComponent, data: { title: 'Gestión de Reglas' }, canActivate: [RouteGuard] },
    { path: 'facturacion/primas', component: BillingManagementComponent, data: { title: 'Gestión de Primas' }, canActivate: [RouteGuard] },
    { path: 'facturacion/periodos', component: PeriodManagementComponent, data: { title: 'Mantenimiento de Periodos' }, canActivate: [RouteGuard] },
    { path: 'facturacion/pagos', component: PaymentManagementComponent, data: { title: 'Gestión de Pagos' }, canActivate: [RouteGuard] },
    { path: 'facturacion/reembolsos', component: ReimbursementManagementComponent, data: { title: 'Gestión de Reembolsos' }, canActivate: [RouteGuard] },
    { path: 'solicitudes/historial', component: RequestHistoryComponent, data: { title: 'Historial de Solicitudes' }, canActivate: [RouteGuard] },
    { path: 'solicitudes/sesion/entrar/:token', component: SessionPageComponent, data: { title: 'Entrar a la sesión' }, canActivate: [RouteGuard] },
    { path: 'solicitudes/sesion/:uuid', component: SessionPageComponent, data: { title: 'Sesión de comisión' }, canActivate: [RouteGuard] },
    { path: 'solicitudes/sesion', component: SessionPageComponent, data: { title: 'Sesión de comisión' }, canActivate: [RouteGuard] },
    {
        matcher: prefixMatcher('solicitudes'),
        component: RequestsComponent,
        canActivate: [RouteGuard],
        data: { title: 'Solicitudes' }
    },
    { path: '**', component: HomePage, data: { title: '404 Error' } }
];
